import { useMemo } from "react";
import PropTypes from "prop-types";
import { hasRoles } from "../../utils/security";
import useUser from "../../hooks/useUser";

const PrivateAccess = ({ roles, children }) => {
  const user = useUser();
  const isAuthorized = useMemo(() => {
    return user && hasRoles(roles, user.roles);
  }, [roles, user]);

  return isAuthorized ? children : null;
};

PrivateAccess.displayName = "PrivateAccess";

PrivateAccess.defaultProps = {
  children: null,
  roles: null,
};

PrivateAccess.propTypes = {
  /** Anything that can be rendered  */
  children: PropTypes.node,
  /** Object with properties. The property of object is keycloak client name, the value is array with keycloak roles.
   *  Example: { firstClient: [ "ADMIN" ], secondClient: [ "MANAGER" ] }
   */
  roles: PropTypes.object,
};

export default PrivateAccess;
